import React from 'react';
import Table from 'antd/lib/table';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import InputNumber from 'antd/lib/input-number';
import 'antd/lib/input-number/style/index.css';
import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import InputCountryCode from './InputCountryCode';
var TableAthleteCsv = function (props) {
    var columns = [{
            title: 'Bib number',
            dataIndex: 'bibNumber',
            key: 'bibNumber',
            fixed: 'left',
            render: function (bibNumber, athlete, i) { return (React.createElement(InputNumber, { min: 1, max: 999, style: { width: '70px' }, value: bibNumber, disabled: props.isDisabled, onChange: function (value) { return props.handleUpdateRow({ bibNumber: value }, i); } })); },
        }, {
            title: 'Athlete name',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            render: function (name, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: name, onChange: function (event) { return props.handleUpdateRow({ name: event.target.value }, i); } })); },
        }, {
            title: 'Team name',
            dataIndex: 'teamName',
            key: 'teamName',
            render: function (teamName, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: teamName, onChange: function (event) { return props.handleUpdateRow({ teamName: event.target.value }, i); } })); },
        }, {
            title: 'Gender',
            dataIndex: 'gender',
            key: 'gender',
            render: function (gender, athlete, i) { return (React.createElement(Select, { style: { width: '100px' }, disabled: props.isDisabled, value: gender, onChange: function (value) { return props.handleUpdateRow({ gender: value }, i); } },
                React.createElement(Select.Option, { value: 'female' }, "Female"),
                React.createElement(Select.Option, { value: 'male' }, "Male"))); },
        }, {
            title: 'Affiliation',
            dataIndex: 'affiliation',
            key: 'affiliation',
            render: function (affiliation, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: affiliation, onChange: function (event) { return props.handleUpdateRow({ affiliation: event.target.value }, i); } })); },
        }, {
            title: 'Country Code',
            dataIndex: 'countryCode',
            key: 'countryCode',
            render: function (countryCode, athlete, i) { return (React.createElement(InputCountryCode, { isDisabled: props.isDisabled, value: countryCode, onChange: function (value) { return props.handleUpdateRow({ countryCode: value }, i); } })); },
        }, {
            title: 'Country State',
            dataIndex: 'countryState',
            key: 'countryState',
            render: function (countryState, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: countryState, onChange: function (event) { return props.handleUpdateRow({ countryState: event.target.value }, i); } })); },
        }, {
            title: 'Email (Private)',
            dataIndex: 'email',
            key: 'email',
            render: function (email, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: email, onChange: function (event) { return props.handleUpdateRow({ email: event.target.value }, i); } })); },
        }, {
            title: 'Identifier (Private)',
            dataIndex: 'identifier',
            key: 'identifier',
            render: function (identifier, athlete, i) { return (React.createElement(Input, { disabled: props.isDisabled, value: identifier, onChange: function (event) { return props.handleUpdateRow({ identifier: event.target.value }, i); } })); },
        }];
    if (!props.isTeamCategory) {
        columns.splice(2, 1);
    }
    return (React.createElement(Table, { columns: columns, dataSource: props.athletes, size: 'small', scroll: { x: props.isTeamCategory ? 1500 : 1280 }, rowKey: function (athlete, i) { return String(i); }, locale: { emptyText: props.emptyText } }));
};
export default TableAthleteCsv;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthleteCsvPage/TableAthleteCsv.tsx
// module id = 1319
// module chunks = 0